export const MONTH_OPTIONS = [
    { displayName: "January", value: "January" },
    { displayName: "February", value: "February" },
    { displayName: "March", value: "March" },
    { displayName: "April", value: "April" },
    { displayName: "May", value: "May" },
    { displayName: "June", value: "June" },
    { displayName: "July", value: "July" },
    { displayName: "August", value: "August" },
    { displayName: "September", value: "September" },
    { displayName: "October", value: "October" },
    { displayName: "November", value: "November" },
    { displayName: "December", value: "December" },
];
